import script from "./JobListView.vue?vue&type=script&setup=true&lang=ts"
export * from "./JobListView.vue?vue&type=script&setup=true&lang=ts"

import "./JobListView.vue?vue&type=style&index=0&id=5080d386&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5080d386"]])

export default __exports__